// extracted by mini-css-extract-plugin
export default {"name":"name_name__5n-v7","title":"name_title__YqCI4","label":"name_label__tOB5Z"};